














export default {
  name: 'UserChip',
  props: {user: Object},
  data() {
    return {
      id: 'input-' + String(Math.floor((Math.random() * 100000))),
      showTooltip: true,
    }
  },
}
